import { KText } from '@/ui-library/components/text';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Button,
  ModalHeader,
  ModalFooter,
} from '@chakra-ui/react';

export const ModalWrapper = ({
  isOpen,
  onClose,
  headerText = '',
  subHeaderText = '',
  BodyBlock = () => <></>,
  handleSubmit = () => {},
  isCtaLoading = false,
  primaryCtaText = 'Submit',
  isCtaDisabled = false,
  secondaryCtaText = 'Cancel',
  isCustomSecondary = false,
  customSecondary = () => {},
  showFooter = true,
  modalBodyProps = {},
  primaryButtonProps = {},
  modalContentProps = {},
  primaryVariant = 'primary',
  modalHeaderProps = {},
  modalFooterProps = {},
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent bg={'white'} {...modalContentProps}>
        <ModalHeader py="12px" {...modalHeaderProps}>
          <KText size="md-medium" color="secondary-900">
            {headerText}
          </KText>
          {subHeaderText && (
            <KText size="sm-medium" mt="xs">
              {subHeaderText}
            </KText>
          )}
        </ModalHeader>
        <ModalBody maxH="500px" overflowY="auto" py="0" {...modalBodyProps}>
          <BodyBlock />
        </ModalBody>
        {showFooter && (
          <ModalFooter {...modalFooterProps}>
            <Button
              variant="secondary"
              mr="12px"
              onClick={isCustomSecondary ? customSecondary : onClose}
              data-test-id="secondary-cta-button"
            >
              {secondaryCtaText}
            </Button>
            <Button
              isLoading={isCtaLoading}
              variant={primaryVariant}
              onClick={handleSubmit}
              isDisabled={isCtaDisabled}
              {...primaryButtonProps}
              data-test-id="primary-cta-button"
            >
              {primaryCtaText}
            </Button>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};
